import { DBSystemCode } from '@home/_config/config';

import type { IAISearchPageSupportConfig } from '@home/types/aiSearch';

const AI_SEARCH_PAGE_SUPPORT_CONFIG: IAISearchPageSupportConfig = {
  system: DBSystemCode.Marketing,
  mode: 'blacklist',
  routes: [
    {
      matchType: 'exact',
      pathname: '/marketing/Hashtag',
    },
    {
      matchType: 'exact',
      pathname: '/marketing/Videos',
    },
    {
      matchType: 'exact',
      pathname: '/marketing/Memes',
    },
    {
      matchType: 'exact',
      pathname: '/marketing/CompetitorsAdCreatives',
    },
    {
      matchType: 'exact',
      pathname: '/marketing/MahjongSolitaire/TopCreatives',
    },
    {
      matchType: 'exact',
      pathname: '/marketing/MahjongSolitaire/TrendingPublications',
    },
    {
      matchType: 'exact',
      pathname: '/marketing/Arrows/TopCreatives',
    },
    {
      matchType: 'exact',
      pathname: '/marketing/Arrows/TrendingPublications',
    },
  ],
};

export default AI_SEARCH_PAGE_SUPPORT_CONFIG;
